import { createSelector } from 'reselect'

export const getCustomOfferV2ScheduleRequestInfo = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (order): App.Checkout.CustomOfferPaymentScheduleRequestInfo | null => {
    const v2 = order?.customOfferItems?.[0]?.custom_offer?.payment_metadata?.payment_flow_v2
    if (v2?.type !== 'payment_schedule' || !v2.deposit_amount || !v2.balance_amount || !v2.balance_due_date) {
      return null
    }
    return {
      templateId: 'custom_offer',
      deposit_amount: v2.deposit_amount,
      balance_amount: v2.balance_amount,
      balance_due_date: v2.balance_due_date,
    }
  },
)
